exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-___app__wrapper___1xwtw{min-height:100vh;position:relative}.src-components-___app__content___17QoG{padding:80px 20px 95px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-___app__wrapper___1xwtw",
	"content": "src-components-___app__content___17QoG"
};